import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../../utils/helper";
import { baseQueryWithAuth } from "../../../BaseQueryWithAuth/baseQueryWithAuth";

export const balancefitnessApiService = createApi({
  reducerPath: "balancefitnessApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    createBalance: builder.mutation({
      query: ({ payload, params }) => {
        const query = queryParams(params);
        return {
          url: `balancetest/create${query}`,
          method: "POST",
          body: payload,
        };
      },
    }),
    getBalance: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `balancetest/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
    updateBalance: builder.mutation({
      query: ({ id, params, ...payload }) => {
        const query = queryParams(params);
        return {
          url: `balancetest/${id}${query}`,
          method: "PUT",
          body: payload,
        };
      },
    }),
    getBalanceChart: builder.query({
      query: (data) => {
        let query = queryParams(data);
        return `balancetest/chart-data${query}`;
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const {
  useCreateBalanceMutation,
  useGetBalanceQuery,
  useUpdateBalanceMutation,
  useGetBalanceChartQuery,
} = balancefitnessApiService;
